// extracted by mini-css-extract-plugin
export default {"buttonContianer":"DrivePermissionModal__buttonContianer___kW0qy","articleLink":"DrivePermissionModal__articleLink___Cr_eZ"};